module.exports = __webpack_public_path__ + "static/media/obxLogo@2x.28d02189.png";